import './Load.css';
import loader from '../../Media/loader.gif';

const Load = () => {
    return ( 
        <div className="load">
            <img src={loader} alt="loading"/>
            
        </div>
     );
}
 
export default Load;